import React from "react";
import MyRoutes from "./User/Routes/MyRoutes";
import { ToastProvider } from "./User/Components/Toast/ToastProvider";
import { NotificationProvider } from "./User/Components/Notification/NotificationProvider";

const App = () => {
  return (
    <ToastProvider>
      <NotificationProvider>
        <MyRoutes />
      </NotificationProvider>
    </ToastProvider>
  );
};

export default App;
